export default {
  jobListing: "/job-list",
  jobDetail: "/job-detail",
  jobApply: "/job-apply",
};
